import React from "react";

// Generic job-form modal shell — renders section headers + fields (text,
// number, date, select, checkbox, textarea) from a field-definition array.
// Any field with `readOnly: true` renders disabled, which is how view-only
// popups (e.g. Job History) reuse this without a separate component.
const JobFormModal = ({
  show, titleContent, formFields, formData, onChange,
  onClose, onSubmit, submitText = "Save",
}) => {
  if (!show) return null;

  const renderField = (field, key) => {
    if (field.display === "none") return null;

    if (field.type === "checkbox") {
      return (
        <div className={`col-md-${field.col || 3} d-flex align-items-end`} key={key}>
          <div className="form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id={field.name}
              name={field.name}
              checked={!!formData[field.name]}
              disabled={field.readOnly}
              onChange={(e) => onChange({ target: { name: field.name, value: e.target.checked } })}
            />
            <label className="form-check-label fw-semibold" htmlFor={field.name} style={{ fontSize: 13 }}>
              {field.label}
            </label>
          </div>
        </div>
      );
    }

    const commonProps = {
      id: field.name,
      name: field.name,
      className: field.type === "select" ? "form-select form-select-sm" : "form-control form-control-sm",
      value: formData[field.name] ?? "",
      onChange,
    };

    let control;
    if (field.type === "select") {
      control = (
        <select {...commonProps} disabled={field.readOnly}>
          {(field.options || []).map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
      );
    } else if (field.type === "textarea") {
      control = <textarea {...commonProps} rows={3} readOnly={field.readOnly} />;
    } else {
      control = <input type={field.type || "text"} {...commonProps} readOnly={field.readOnly} />;
    }

    return (
      <div className={`col-md-${field.col || 6}`} key={key}>
        <label className="form-label fw-semibold" style={{ fontSize: 13 }} htmlFor={field.name}>
          {field.label}
          {field.required && <span className="text-danger"> *</span>}
        </label>
        {control}
      </div>
    );
  };

  return (
    <>
      <div className="modal-backdrop fade show" style={{ zIndex: 1055 }} onClick={onClose} />
      <div className="modal fade show d-block" style={{ zIndex: 1056 }} tabIndex="-1">
        <div className="modal-dialog modal-xl modal-dialog-scrollable">
          <div className="modal-content" style={{ borderRadius: 12, overflow: "hidden" }}>

            <div className="modal-header" style={{ background: "rgba(10,24,50,0.97)", color: "#fff" }}>
              <div>{titleContent}</div>
              <button type="button" className="btn-close btn-close-white" style={{ color: "#fff" }} onClick={onClose} />
            </div>

            <div className="modal-body" style={{ background: "#f8f9fa" }}>
              <div className="row g-3">
                {formFields.map((field, idx) => {
                  if (field.type === "section") {
                    return (
                      <div className="col-12" key={`section_${idx}`}>
                        <h6
                          className="fw-bold mt-2 mb-1"
                          style={{ color: "#1e40af", borderBottom: "2px solid #e2e8f0", paddingBottom: 4 }}
                        >
                          {field.label}
                        </h6>
                      </div>
                    );
                  }
                  return renderField(field, field.name || idx);
                })}
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary btn-sm" onClick={onClose}>Close</button>
              {onSubmit && (
                <button className="btn btn-primary btn-sm" onClick={onSubmit}>{submitText}</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default JobFormModal;
